const pageTileMap = {
  '/home': 'Dashboard',
  '/users': 'User Management',
  '/candidates': 'Candidates',
  '/candidate-assignment': 'Candidate Assignment',
  '/clients': 'Clients',
};

export const generatePageTitle = (path) => {
  return _.get(pageTileMap, path, '');
};
